import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/register/page.tsx");
